<template>
  <v-card :height="fillHeight ? '100%' : 'auto'">
    <v-panel-title @click="switchItems()" :value="this.isLoaded && this.items.length > 0" :caption="this.isLoaded ? 'Показать ' + this.topCount : 'Показать все'" :expandable="items.length > topCount">
      <div v-html="formatCapital(capital)"></div>
        <div
          v-show="isLoading"
          class="text-xs-center">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div v-show="!isLoading">
        <component :is="formatHolderRegister(holderRegister)"/>
        <div v-html="formatHoldersHtml(items)"></div>
        <template v-for="item in topHolders">
          <div v-show="item.refObject.namespace === 'ogrn'">
            <component :is="createCompanyComp(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'HUMAN'">
            <component :is="createHumanComp(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'FOREIGN'">
            <component :is="createNoInnHolder(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'MUNICIPAL'">
            <component :is="createNoInnHolder(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'PIF'">
            <component :is="createNoInnHolder(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'OTHER'">
            <span v-html="renderHolderPercent(item)">
            </span>
            <v-flex pl-2>
              <div v-html="formatWarningHtml('Запись об учредителе не поддерживается.')" ></div>
              <div><b>{{formatShare(item)}}</b>{{renderDateSince(item)}}</div>
            </v-flex>
          </div>
          <span v-html="renderUnreliableHtml(item)"></span>
        </template>
      </div>
    </v-panel-title>
    <v-card-text v-show="isLoaded" class="pt-0">
      <div v-show="!isLoading">
        <v-flex v-if="items.length===0">
          Данные не найдены.
        </v-flex>
        <div v-show = "items.length > 0 && items.length > 100">
          <b>ВАЖНО!</b> Показываются только 100 учредителей, отфильтрованных по величине доли. Для показа всех учредителей направьте нам письмо на электронную почту {{getOpenSettings.supportMail}}<br/><br/>
        </div>
        <template v-for="item in lowHolders">
          <div v-show="item.refObject.namespace === 'ogrn'">
            <component :is="createCompanyComp(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'HUMAN'">
            <component :is="createHumanComp(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'FOREIGN'">
            <component :is="createNoInnHolder(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'MUNICIPAL'">
            <component :is="createNoInnHolder(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'PIF'">
            <component :is="createNoInnHolder(item)"/>
          </div>
          <div v-show="item.refObject.namespace === 'OTHER'">
            <span v-html="renderHolderPercent(item)">
            </span>
            <v-flex pl-2>
              <div v-html="formatWarningHtml('Запись об учредителе не поддерживается.')" ></div>
              <div><b>{{formatShare(item)}}</b>{{renderDateSince(item)}}</div>
            </v-flex>
          </div>
          <span v-html="renderUnreliableHtml(item)"></span>
        </template>
      </div>
      </v-card-text>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import server from '../../api/server'
  import formats from '../../api/formats'
  import vPanelTitle from './PanelTitle'
  import people from '../people/index.js'

  export default {
    name: 'v-holder-panel',
    components: {vPanelTitle},
    data: () => ({
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    }),
    props: {
      ogrn: {
        type: Number,
        default: null
      },
      capital: {
        type: Object,
        default: null
      },
      holderRegister: {
        type: Object,
        default: null
      },
      topCount: {
        type: Number,
        default: 5
      },
      fillHeight: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      ogrn: function (newVal, oldVal) { // watch it
        this.id = newVal
        if (this.id) {
          this.fetchItems()
        }
      }
    },
    computed: {
      ...mapGetters({
        renderReference: 'renderReference',
        renderHolderPercent: 'renderHolderPercent',
        renderInnHtml: 'renderInnHtml',
        renderInnflHtml: 'renderInnflHtml',
        renderDateSince: 'renderDateSince',
        renderUnreliableHtml: 'renderUnreliableHtml',
        renderCopyButton: 'renderCopyButton',
        renderContactButton: 'renderContactButton',
        getIconName: 'getIconName',
        getOpenSettings: 'getOpenSettings'
      }),
      topHolders () {
        return this.holders.slice(0, this.topCount)
      },
      lowHolders () {
        console.log('lowHolders', this.holders.slice(this.topCount, 100))
        return this.holders.slice(this.topCount, 100)
      },
      holders () {
        return this.items.sort((a, b) => {
          var result = formats.getValue(b, ['shares', 0, 'share']) - formats.getValue(a, ['shares', 0, 'share'])
          return result !== 0 ? result : (formats.compareString(a.name, b.name))
        })
      }
    },
    methods: {
      switchItems () {
        this.isLoaded = !this.isLoaded
        if (this.isLoaded && this.items.length === 0) {
          this.fetchItems()
        }
      },
      formatCurrency (number) {
        return number != null ? formats.formatCurrency(number) + ' руб.' : ''
      },
      formatWarningHtml (warning) {
        return formats.formatWarningHtml(warning)
      },
      formatCapital (capital) {
        if (!capital) {
          return formats.formatWarningHtml('ЕГРЮЛ не содержит запись об уставном капитале компании')
        }
        return ''.concat(
          '<div>',
          capital.type ? capital.type + ':' : formats.formatWarningHtml('ЕГРЮЛ не содержит запись о типе уставнго капитала'),
          ' <b>' + this.formatCurrency(capital.value) + '</b>',
          this.renderDateSince(capital),
          '</div>',
          '<div>',
          this.formatLessenings(capital),
          formats.formatWarningHtml(capital.desc),
          '</div>'
          )
      },
      formatLessenings (capital) {
        if (!capital.lessenings) {
          return ''
        }
        var result = ''
        capital.lessenings.forEach(l => {
          result = result.concat(
          '<div>',
          '\xa0\xa0',
          'Уменьшение капитала на ',
          this.formatCurrency(l.value),
          this.renderDateSince(l),
          '</div>'
          )
        })
        return result
      },
      formatHolderRegister (holderRegister) {
        var self = this
        var template = ''.concat(holderRegister ? `
          <div>
            Держатель реестра акционеров:
            <div v-html="self.renderReference(dto.value)">
            </div>
            <v-flex pl-2>
              <div>ИНН <b><span v-html="self.renderInnHtml(dto.value.inn)"></span></b>
              </div>
              <span v-html="self.renderDateSince(dto)"></span>
            </v-flex>
          </div>
          ` : `<div></div>`
          // `<div v-html="formats.formatWarningHtml('ЕГРЮЛ не содержит запись о регистраторе')"></div>`
        )
        return {
          template: template,
          data: function () {
            return {
              self: self,
              dto: holderRegister,
              formats: formats
            }
          }
        }
      },
      formatHoldersHtml (holders) {
        return holders && holders.length > 0 ? `Учредители (${holders.length > 100 ? 'более 100' : holders.length})` : formats.formatWarningHtml('ЕГРЮЛ не содержит запись об учредителях компании')
      },
      formatShare (holder) {
        return this.formatCurrency(formats.getValue(holder, ['shares', '0', 'share']))
      },
      formatHumanCountersHtml (counters) {
        const _f = v => v !== null ? v : 'нет данных'
        if (!counters) {
          return '<div></div>'
        }
        var result = ''.concat(
          `<v-tooltip bottom>`,
          `<span slot="activator">`,
          `<v-icon small>${this.getIconName('head')}</v-icon>${_f(counters.managedCompaniesExact)}(${_f(counters.managedCompaniesGeneral)})&nbsp`,
          `<v-icon small>${this.getIconName('holder')}</v-icon>${_f(counters.sharedCompaniesExact)}(${_f(counters.sharedCompaniesGeneral)})`,
          `<v-icon small>${this.getIconName('loner')}</v-icon>${_f(counters.loners)}`,
          `</span>`,
          `<span>Управление и участие в компаниях, наличие ИП <br/> точное (не точное) совпадение</span>`,
          `</v-tooltip>`
          )
        return result
      },
      createCompanyComp (item) {
        var self = this
        var template = `
        <div>
          <span v-html="self.renderHolderPercent(item)"></span>
          <v-component :is="self.renderCopyButton('Копировать название', getNameFull)" />
          <v-flex pl-2>
            <div>
              ИНН <span v-html="self.renderInnHtml(item.refObject.inn)"></span>
              <v-component :is="self.renderCopyButton('Копировать инн', getInn)" />
            </div>
            <div><b>{{self.formatShare(item)}}</b>{{self.renderDateSince(item)}}</div>
          </v-flex>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              item: item
            }
          },
          methods: {
            getNameFull () {
              return self.getHumanNameFull(item)
            },
            getInn () {
              return self.getHumanInn(item)
            }
          }
        }
      },
      createHumanComp (item) {
        var self = this
        var template = `
        <div>
          <span v-html="self.renderHolderPercent(item)"></span>
          <component :is="self.createComp(self.formatHumanCountersHtml(item.refObject.counters))"/>
          <v-component :is="self.renderCopyButton('Копировать ФИО', getNameFull)" />
          <v-component :is="self.renderContactButton('Открыть контакт физического лица', openContact)" />
          <v-flex pl-2>
            <div>
              ИНН <span v-html="self.renderInnflHtml(item.refObject.inn)"></span>
              <v-component :is="self.renderCopyButton('Копировать инн', getInn)" />
            </div>
            <div><b>{{self.formatShare(item)}}</b>{{self.renderDateSince(item)}}</div>
          </v-flex>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              item: item
            }
          },
          methods: {
            getNameFull () {
              return self.getHumanNameFull(item)
            },
            getInn () {
              return self.getHumanInn(item)
            },
            openContact () {
              let names = this.getNameFull().split(' ')
              let ops = {
                inn: this.getInn(),
                lastName: names.length > 0 ? names[0] : '',
                firstName: names.length > 1 ? names[1] : '',
                middleName: names.length > 2 ? names[2] : '',
                position: 'Участник'
              }
              people.openByHuman('ogrn:' + self.id, ops)
            }
          }
        }
      },
      createNoInnHolder (item) {
        var self = this
        var template = `
        <div>
          <span v-html="self.renderHolderPercent(item)"></span>
          <v-component :is="self.renderCopyButton('Копировать название', getNameFull)" />
          <v-flex pl-2>
            <div><b>{{self.formatShare(item)}}</b>{{self.renderDateSince(item)}}</div>
          </v-flex>
        </div>
        `
        return {
          template: template,
          data: function () {
            return {
              self: self,
              item: item
            }
          },
          methods: {
            getNameFull () {
              return self.getHumanNameFull(item)
            }
          }
        }
      },
      getHumanNameFull (item) {
        return `${formats.getValue(item, ['refObject', 'name'])}`
      },
      getHumanInn (item) {
        return `${formats.formatInnfl(formats.getValue(item, ['refObject', 'inn']))}`
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации об учередителях компании из ЕГРЮЛ '})
        }
        server.openApiGet(
          '/openapi/companies/' + id + '/holders',
          cb,
          cbError)
      },
      fetchItems () {
        if (this.id && !this.isLoading) {
          this.items = []
          this.isLoading = true
          this.getItems(this.id, (data) => {
            this.items = data
            this.isLoading = false
          })
        }
      },
      createComp (template) {
        return formats.createComp(template)
      },
      getItemsLength (items) {
        return items ? items.length : 0
      }
    }
  }

</script>




// WEBPACK FOOTER //
// HoldersPanel.vue?845c25d2